<template>
  <header class="asd20-app-header">
    <asd20-button
      v-show="!zoomed"
      class="back-button"
      icon="chevron"
      :icon-angle="-90"
      size="xs"
      :label="backLabel"
      transparent
      horizontal
      text-only
      :link="backLink"
    ></asd20-button>
    <h1>
      <div
        :class="
          zoomed
            ? 'asd20-app-header__title asd20-app-header__zoomed'
            : 'asd20-app-header__title'
        "
      >
        <asd20-icon v-if="icon" :name="icon" size="md" />
        {{ title }}
      </div>
      <asd20-district-logo link="https://www.asd20.org" />
    </h1>
    <!-- <span class="version" v-if="version && !zoomed" v-html="version"></span> -->
    <slot />
  </header>
</template>

<script>
import Asd20Button from '../../atoms/Asd20Button'
import Asd20Icon from '../../atoms/Asd20Icon'
import Asd20DistrictLogo from '../../atoms/Asd20DistrictLogo'

export default {
  name: 'Asd20AppHeader',
  components: { Asd20Button, Asd20Icon, Asd20DistrictLogo },
  props: {
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
    version: { type: String, default: '' },
    backLink: { type: String, default: 'https://www.asd20.org' },
    backLabel: { type: String, default: 'asd20.org' },
  },
  data: () => ({
    zoomed: false,
  }),
  mounted() {
    this.zoomed = window.innerHeight <= 500
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.zoomed = window.innerHeight <= 500
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';
.asd20-app-header {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background: var(--color__primary);
  color: white;
  // background: white;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--color__tertiary);

  &__title {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0 0 space(0.5) 0;
    // width: 100vw;
    // border-bottom: 1px solid var(--color__tertiary);
  }
  &__zoomed,
  .asd20-district-logo {
    padding: 0 !important;
  }

  h1 {
    margin: 0;
    font-size: 1.5rem;
    color: var(--color__on-primary);
    flex-grow: 1;
    width: 100%;
    border-bottom: 1px solid var(--color__tertiary);
    display: flex;
    align-items: center;
    font-family: var(--website-typography__font-family-headlines);
    .asd20-icon {
      margin: 0 space(0.5);
      --line-color: white;
    }
  }
  .version {
    position: absolute;
    top: space(3);
    right: space(-0.45);
    display: block;
    font-size: 0.75rem;
    font-family: var(--website-typography__font-family-headlines);
    color: lightgray;
    text-transform: uppercase;
    margin-left: space(0.5);
    margin-right: space(0.5);
    order: 2;
  }

  .asd20-district-logo {
    margin-left: auto;
    margin-right: space(1);
    height: space(1.5);
    padding: space(0.5) 0;
    --fill-one: #fff;
    --fill-two: #ccc;
    // --fill-one: #{asd20-color('brand-blue')};
    // --fill-two: #{asd20-color('brand-gray')};
  }

  .asd20-button {
    margin-left: auto;
    margin-right: space(0.5);
    order: 3;
    border-radius: 0;
  }

  .asd20-button + .asd20-button {
    margin-left: 0;
  }
  .asd20-button:not(.back-button) {
    border-left: 1px solid var(--color__tertiary);
  }

  .asd20-button.asd20-button--transparent {
    margin-right: 0;
  }
  .back-button {
    // width: 100vw;
    background: var(--color__primary);
    // flex-grow: 1;
    margin: 0;
    order: 0;
    font-size: 0.875rem !important;
    font-weight: bold;
    padding: space(0.5) space(0.5) space(0.5) space(0.5);
    color: var(--color__on-primary);
    // margin-bottom: space(-0.5);
    &::v-deep .asd20-icon {
      --line-color: var(--color__on-primary) !important;
    }
  }
}

@media (max-width: 767px) {
  .asd20-app-header::v-deep .asd20-district-logo {
    display: none;
  }
  .asd20-app-header {
    h1 .version {
      display: none;
    }
    .asd20-button:not(.back-button) {
      &::v-deep .asd20-button__label {
        display: none;
      }
    }
    .asd20-app-header__title {
      padding: space(0.125) 0;
      &::v-deep .asd20-icon {
        margin-right: space(0.125);
      }
    }
  }
}

@media (max-width: 480px) {
  .asd20-app-header {
    &__title {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      padding: space(0.5) 0;
      width: 100vw;
      border-bottom: 1px solid var(--color__tertiary);
    }
  }
}
</style>
